const eur = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });
const TZ = "Europe/Rome";

const PUBLIC_RE = /^\/($|(it|en|fr|de|es|ru|pt|ko)(\/|$)|sito\/|hotel\/|destinazioni\/|shop|collezione\/|magazine|guida|legale\/|privacy-policy|cookie-policy|vintage|amalfi-through-our-eyes|pagamento\/|b\/|c\/|r\/)/;
export function formatEUR(minor) {
  if (minor == null || isNaN(minor)) return "—";
  const pl = typeof document !== "undefined" && PUBLIC_RE.test(window.location.pathname) ? (document.documentElement.lang || "it").slice(0, 2) : "it";
  if (pl !== "it" && LOC[pl]) return formatEURL(minor, pl);
  return eur.format(minor / 100);
}

const LOC = { it: "it-IT", en: "en-GB", fr: "fr-FR", de: "de-DE", es: "es-ES", ru: "ru-RU", pt: "pt-BR", ko: "ko-KR" };
const EURL = {};
export function formatEURL(minor, lang = "it") {
  if (minor == null || isNaN(minor)) return "—";
  const l = LOC[lang] || LOC.en;
  EURL[l] ||= new Intl.NumberFormat(l, { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: "always" });
  return EURL[l].format(minor / 100);
}

export function toMinor(value) {
  const n = parseFloat(String(value ?? "").replace(",", "."));
  return isNaN(n) ? 0 : Math.round(n * 100);
}

export function fromMinor(minor) {
  return minor == null ? "" : (minor / 100).toFixed(2);
}

export function formatDate(v) {
  if (!v) return "—";
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split("-");
    return `${d}/${m}/${y}`;
  }
  return new Date(v).toLocaleDateString("it-IT", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatDateTime(v) {
  if (!v) return "—";
  return new Date(v).toLocaleString("it-IT", {
    timeZone: TZ, day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit",
  });
}

export function formatTime(v) {
  if (!v) return "—";
  return new Date(v).toLocaleTimeString("it-IT", { timeZone: TZ, hour: "2-digit", minute: "2-digit" });
}

// ISO (UTC) -> "YYYY-MM-DDTHH:mm" in Europe/Rome for datetime-local inputs
export function isoToRomeInput(v) {
  const d = v ? new Date(v) : new Date();
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", {
      timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
    }).formatToParts(d).map((x) => [x.type, x.value])
  );
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

export function romeToday() {
  return isoToRomeInput().slice(0, 10);
}

export function addHoursInput(input, h) {
  const [d, t] = input.split("T");
  const dt = new Date(`${d}T${t}:00Z`);
  dt.setUTCHours(dt.getUTCHours() + h);
  return dt.toISOString().slice(0, 16);
}

export function formatRemaining(min) {
  if (min == null) return "—";
  const abs = Math.abs(min);
  const d = Math.floor(abs / 1440), h = Math.floor((abs % 1440) / 60), m = abs % 60;
  const txt = d ? `${d}g ${h}h` : h ? `${h}h ${m}m` : `${m}m`;
  return min < 0 ? `+${txt} di ritardo` : txt;
}

export const fullName = (p) => (p ? `${p.first_name || ""} ${p.last_name || ""}`.trim() : "—");
